export const routes = {
  providersDirectory: '/providers',
  facilitiesDirectory: '/facilities',
  care: '/care',
  // careDoctors: '/care/doctors',
  // careSpecialties: '/care/specialties',
  // careFacilities: '/care/facilities',
  providerProfile: '/providers/:id',
  facilityProfile: '/facilities/:id'
}

export default routes
